module.exports = __webpack_public_path__ + "static/media/players-stats.6e35a42e.png";